import React, { Component } from "react";
import { getStaticText } from '../../../lables/lablesService';
import VacancyPosts from '../api/vacancyPosts';
import ImageInput from '../../../components/image-input-component/imageInput';
import HtmlInput from '../../../components/html-input-component/htmlInput';


class VacancyForm extends Component {

	constructor(props) {
        super(props);

        this.save_process = false;
        this.state = {
        	'increment' : 0
        };
    }


    changePostInfo ( prop_name, prop_value ) {
    	let value = null;
        switch (prop_name) {
            case 'content':
                    value = prop_value;
                break;

            case 'active':
                    value = prop_value.target.checked ? 1 : 0;
                break;

            default:
                    value = prop_value.target.value
                break;
        }
        this.props.info[prop_name] = value;
    }


    changePostImage ( image_name, image ) {
    	this.props.info.image_name = image_name;
        this.props.info.image = image;
        this.setState({
            'increment' : this.state.increment + 1
        });
    }


    async savePost () {
    	if ( this.save_process )
            return false;

        this.save_process = true;

        const formData = new FormData();

        if ( this.props.info.id > 0 )
            formData.append( 'id', this.props.info.id );

        if ( typeof(this.props.info.image) === 'object' )
            formData.append( 'image', this.props.info.image );

        formData.append( 'title', this.props.info.title );
        formData.append( 'content', this.props.info.content );
        formData.append( 'type_id', this.props.info.type_id );
        formData.append( 'active', this.props.info.active );

        let result = null;
        if ( this.props.info.id === 0 )
            result = await VacancyPosts.add( formData );
        else
            result = await VacancyPosts.update( formData );
    
        if ( !result ) {
            window.alert( getStaticText('save_error') );
        } else {
            window.alert( getStaticText('save_success') );
            if ( typeof(this.props.formCallback) === 'function' )
            	this.props.formCallback();
        }
        
        this.save_process = false;
    }


	render () {
		let types_for_select = [];
		types_for_select.push(<option key="vp_type_id_opt_0" value={0}>{getStaticText('vp_form_type_id_empty_opt')}</option>);
		for ( let id in this.props.categories ) {
			types_for_select.push(<option key={"vp_type_id_opt_" + id} value={id}>{this.props.categories[id]}</option>);
		}

		return (<>
				<ImageInput 
                    label={getStaticText('vp_form_image_input_label')}
                    fileImage={this.props.info.image || null}
                    fileName={this.props.info.image_name || null}
                    handleFile={this.changePostImage.bind(this)}
                />

                <div className="form-group">
                    <label
                        htmlFor="vpTitleInput"
                    >
                        {getStaticText('vp_form_title_input_label')}
                    </label>
                    <input 
                        id="vpTitleInput"
                        className="form-control"
                        defaultValue={this.props.info.title}
                        onChange={this.changePostInfo.bind(this, 'title')}
                    />
                </div>

                <div className="form-group">
                    <label
                        htmlFor="vpTypeIdInput"
                    >
                        {getStaticText('vp_form_type_id_input_label')}
                    </label>
                    <select 
                        id="vpTypeIdInput"
                        className="form-control"
                        defaultValue={this.props.info.type_id}
                        onChange={this.changePostInfo.bind(this, 'type_id')}
                    >
                    	{types_for_select}
                    </select>
                </div>

                <HtmlInput 
                    label={getStaticText('vp_form_content_input_label')}
                    content={this.props.info.content}
                    inputName="content"
                    onChangeContent={this.changePostInfo.bind(this)}
                />

                <div className="form-group">
                    <label>
                        <input 
                            type="checkbox"
                            defaultChecked={this.props.info.active}
                            onChange={this.changePostInfo.bind(this, 'active')}
                        /> {getStaticText('vp_form_active_input_label')}
                    </label>
                </div>

                <div className="form-group os-text-right">
                    <button
                        className="btn btn-success"
                        onClick={this.savePost.bind(this)}
                    >
                        {this.props.info.id ? getStaticText('vp_form_update_button_label') : getStaticText('vp_form_add_button_label')}
                    </button>
                </div>
			</>);
	}
}


export default VacancyForm;